import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0233f7aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-monitor" }
const _hoisted_2 = { class: "container clearfix" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("aside", { class: "info fl" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/logo.png" }),
  /*#__PURE__*/_createElementVNode("h1", null, "公司地址"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("江苏省南京市栖霞区马群街道金马路6号7幢 "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://map.baidu.com/poi/%E5%85%AB%E7%88%AA%E6%95%99%E8%82%B2%E6%80%BB%E9%83%A8/@13237009.805557787,3749822.839842726,18.95z?uid=cdc4311e87b2630a72210b09&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl",
      target: "_blank"
    }, "地图")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "TEL：400-826-8090")
], -1))
const _hoisted_4 = { class: "menu fl" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<aside class=\"code-list fl\" data-v-0233f7aa><ul data-v-0233f7aa><li data-v-0233f7aa><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/images/20230807/7340db429c9d48f2ba878aef7bd6cfaf.png\" alt=\"抖音号\" data-v-0233f7aa><p data-v-0233f7aa>八爪招生抖音号</p></li><li data-v-0233f7aa><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/images/20230807/f0370b80f0894855ac8923e981e842bc.png\" alt=\"视频号\" data-v-0233f7aa><p data-v-0233f7aa>八爪畅学视频号</p></li><li data-v-0233f7aa><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/officialaccounts.png\" alt=\"公众号\" data-v-0233f7aa><p data-v-0233f7aa>八爪畅学公众号</p></li><li data-v-0233f7aa><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/user.jpg\" alt=\"用户端\" data-v-0233f7aa><p data-v-0233f7aa>八爪畅学用户端小程序</p></li><li data-v-0233f7aa><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/appcode.jpg\" alt=\"APP\" data-v-0233f7aa><p data-v-0233f7aa>八爪畅学机构端APP</p></li></ul></aside>", 1)
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filing-number" }, [
  /*#__PURE__*/_createTextVNode("Copy © 2021 南京八爪教育科技有限公司        版权所有 "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://beian.miit.gov.cn/",
    target: "_blank"
  }, "备案号:苏ICP备2022035886号")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/images/20230807/7340db429c9d48f2ba878aef7bd6cfaf.png" }),
  /*#__PURE__*/_createElementVNode("p", null, "八爪畅学"),
  /*#__PURE__*/_createElementVNode("p", null, "抖音号")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/images/20230807/f0370b80f0894855ac8923e981e842bc.png" }),
  /*#__PURE__*/_createElementVNode("p", null, "八爪畅学"),
  /*#__PURE__*/_createElementVNode("p", null, "视频号")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/user.jpg" }),
  /*#__PURE__*/_createElementVNode("p", null, "八爪畅学"),
  /*#__PURE__*/_createElementVNode("p", null, "用户端小程序")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/store.png" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "下载八爪畅学", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "机构端APP", -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "address" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("公司地址"),
    /*#__PURE__*/_createElementVNode("span", null, "江苏省南京市栖霞区马群街道金马路6号7幢")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "TEL：400-826-8090")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copy" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Copy © 2021 南京八爪教育科技有限公司 版权所有"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "http://beian.miit.gov.cn/",
      target: "_blank"
    }, "备案号:苏ICP备2022035886号")
  ])
], -1))

import { useRouter } from "vue-router";
import {ref} from 'vue';
import { useStore } from "vuex";
import { key } from "../store";
interface settledConfig {
    flag: boolean;
    type: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFooter',
  setup(__props) {

// 引入useRouter
let store = useStore(key);

// 目录点击跳转路由事件
const router = useRouter();
const toPage = (title: string) => {
    switch(title){
        case "关于八爪":
            router.push({ path: "/" });
            break;
        case "产品服务":
            router.push({ name: "mechanism" });
            break;
        case "新闻中心":
            router.push({ name: "newsList" });
            break;
        case "自律公约":
            router.push({ name: "convention" });
            break;
        case "机构入驻":
            settledActive({ flag:true, type:1 });
            break;
        case "服务商入驻":
            settledActive({ flag:true, type:2 });
            break;
        default:
            break;
    }
}

// PC端-入驻
const settledActive = (obj:settledConfig)=>{
    store.commit("settledActive",obj);
}

// 移动端-机构APP下载
const downloadApp = ()=>{
    window.open("https://bazhuaedu.com/orgapp/baidutongji/bootDownload.html")
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("aside", _hoisted_4, [
            _createElementVNode("ul", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['关于八爪', '产品服务', '新闻中心', '自律公约'], (title, index) => {
                return _createElementVNode("li", {
                  key: index,
                  onClick: _withModifiers(($event: any) => (toPage(title)), ["stop"])
                }, _toDisplayString(title), 9, _hoisted_5)
              }), 64))
            ]),
            _createElementVNode("button", {
              class: "normal-btn",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toPage('机构入驻')), ["stop"]))
            }, "机构入驻"),
            _createElementVNode("button", {
              class: "normal-btn",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (toPage('服务商入驻')), ["stop"]))
            }, "服务商入驻")
          ]),
          _hoisted_6
        ])
      ]),
      _hoisted_7
    ]),
    _createElementVNode("footer", { class: "on-mobile" }, [
      _createElementVNode("section", { class: "footer" }, [
        _createElementVNode("div", { class: "container" }, [
          _createElementVNode("ul", { class: "code-arr" }, [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("li", { onClick: downloadApp }, _hoisted_14)
          ]),
          _hoisted_15,
          _hoisted_16
        ])
      ])
    ])
  ], 64))
}
}

})